import { BookOpenCheck, FileSpreadsheet, ShieldCheck, Users } from "lucide-react";

/**
 * The three services a visitor can price, in one place.
 *
 * Both the landing pages and the in-app navigation read from here, so moving
 * between services never sends anybody off to another website - every link
 * stays inside the calculator app.
 *
 * `accent` is the one secondary colour each service is allowed, used only for
 * small chips, icon tiles and keylines. The teal brand colour still carries
 * every primary action.
 */
export const LANDING_SERVICES = [
  {
    slug: "bookkeeping-fees",
    path: "/bookkeeping-fees",
    service: "bookkeeping",
    short: "Bookkeeping",
    label: "Monthly bookkeeping",
    blurb: "Books, payroll and tax kept current",
    icon: BookOpenCheck,
    accent: "#2f7d6d",
  },
  {
    slug: "financial-statement-fees",
    path: "/financial-statement-fees",
    service: "financial-statements",
    short: "Financial statements",
    label: "Annual financial statements",
    blurb: "Year-end statements prepared by a CA(SA)",
    icon: FileSpreadsheet,
    accent: "#1f3a5f",
  },
  {
    slug: "audit-review-fees",
    path: "/audit-review-fees",
    service: "audit-review",
    short: "Audit & review",
    label: "Audit or independent review",
    blurb: "Independent assurance from Registered Auditors",
    icon: ShieldCheck,
    accent: "#9a6b1a",
  },
  {
    slug: "outsourced-financial-management",
    path: "/outsourced-financial-management",
    service: null,
    short: "Financial management",
    label: "Outsourced financial management",
    blurb: "A led finance team, scoped around your business",
    icon: Users,
    accent: "#5b4a8a",
  },
];

export const serviceBySlug = (slug) =>
  LANDING_SERVICES.find((item) => item.slug === slug) || null;
